import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// CROSS-APP LOGOUT — fires BEFORE React boots so it cannot race with
// AuthProvider's token-validation effect or any HMR'd module:
//  - If the URL is /logout, wipe portal auth and redirect to "/".
//  - If a sub-app set a `gordian_force_logout=1` cookie before redirecting
//    (e.g. RFQ pointed straight at portal home), honour that the same
//    way and consume the cookie.
(() => {
    try {
        const path = window.location.pathname;
        const isLogoutRoute = path === '/logout' || path.startsWith('/logout/');
        const cookieForcesLogout = document.cookie
            .split(';')
            .some((c) => c.trim().startsWith('gordian_force_logout=1'));

        if (isLogoutRoute || cookieForcesLogout) {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('auth_user');
            // Clear the trigger cookie regardless of how it was set so the
            // user is not stuck in a logout loop on the next visit. The
            // setter (RFQ frontend) writes the cookie with Domain=.apex
            // in prod so we MUST delete it with the same attribute —
            // otherwise we just create a host-scoped tombstone and the
            // apex cookie keeps triggering this branch on every load.
            const host = window.location.hostname;
            const isLocal = host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host);
            const apex = isLocal ? '' : host.split('.').slice(-2).join('.');
            const domainAttr = apex ? `; domain=.${apex}` : '';
            document.cookie = `gordian_force_logout=; path=/; max-age=0${domainAttr}`;
            // Belt-and-braces: also clear the host-scoped form in case an
            // older RFQ build set it without a Domain attribute.
            document.cookie = 'gordian_force_logout=; path=/; max-age=0';
            // Bypass React entirely on the way out — no chance for any
            // stale closure or HMR'd auth code to re-validate the token.
            if (window.location.pathname !== '/') {
                window.location.replace('/');
                return;
            }
        }
    } catch {
        /* localStorage / cookie unavailable — fall through to normal boot */
    }

    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement,
    );
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
})();
